import { useMediaQuery } from '@mui/material';
import { createTheme, useTheme } from '@mui/material/styles';

export const theme = createTheme({
	typography: {
		fontFamily: ['Poppins'].join(','),
	},
	palette: {
		background: {
			default: '#f1f9f8',
		},
	},
});

export function useMainCustomStyle() {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

	if (isMobile) {
		return {
			paddingTop: '80px',
			paddingRight: '10px',
			height: '100%',
		};
	} else {
		return {
			paddingLeft: '230px',
			paddingTop: '70px',
			paddingRight: '10px',
			height: '100%',
			paddingBottom: '30px',
		};
	}
}

export const helperText = {
	fontSize: '12px',
	color: 'red',
	paddingBottom: '5px',
	paddingLeft: '10px',
};

export const FileUploadDiv = {
	border: '1px dashed #D9D9D9',
	backgroundColor: '#FFFFFF',
	borderRadius: '5px',
	padding: '50px',
	textAlign: 'center',
	marginBottom: '10px',
};

export const DialogBackground = {
	backgroundColor: 'rgba(0,0,0,0.74)',
};

export const DialogTitleStyle = {
	fontWeight: '600',
	display: 'flex',
	justifyContent: 'space-between',
	boxShadow: '0px 3px 14px -1px rgba(0, 0, 0, 0.08)',
	marginBottom: '24px',
};
